<template>
    <!--            &#45;&#45; Tailwind UI -> Data Display -> Description Lists -> Left-aligned in card &#45;&#45;-->
    <div class="w-full bg-white shadow overflow-hidden sm:rounded-lg">
        <div class="px-4 py-5 border-b border-gray-200 sm:px-6 mb-2 sm:mb-10">
            <p class="mt-1 max-w-2xl text-lg leading-5 text-gray-800">
                When you resolve an alarm, it is considered closed and new alarms may be generated.
                <!--                TODO: Can/Should we indicate if an alarm would be created right now?-->
            </p>
        </div>
<!--                Tailwind UI -> Application UI -> Feedback -> with list -->
        <div class="rounded-md bg-red-50 p-4 m-2 sm:m-10" v-if="willAlarm">
            <div class="flex">
                <div class="shrink-0">
                    <svg class="h-5 w-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                    </svg>
                </div>
                <div class="ml-3">
                    <h3 class="text-sm leading-5 font-medium text-red-800 p-0 text-left">
                        This point is still in an alarm state ({{willAlarm}}) and may re-alarm if you resolve this alarm.
                    </h3>
                </div>
            </div>
        </div>
        <div class="px-4 py-5 sm:p-0">
            <dl>
                <div class="mt-2 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                    <dt class="text-sm leading-5 font-medium text-gray-500">
                        Reason
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                        <select v-model="reason" class="bg-white p-2 w-full border-md rounded-lg border">
                            <option value="" selected="selected" disabled>Please select an alarm reason</option>
                            <option value="Point is back within desired range">Point is back within desired range
                            </option>
                            <option value="Routine maintenance was performed">Routine maintenance was performed</option>
                            <option value="Point is back online">Point is back online</option>
                            <option value="Corrective action taken">Corrective action taken</option>
                            <option value="Other">Other</option>
                        </select>
                    </dd>
                </div>
            </dl>
        </div>
        <div class="px-4 py-5 sm:p-0">
            <dl>
                <div class="mt-2 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                    <dt class="text-sm leading-5 font-medium text-gray-500">
                        Comments
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                        <textarea v-model="comments" class="w-full border-2 p-4" rows="4"></textarea>
                    </dd>
                </div>
            </dl>
        </div>
        <div class="px-4 py-5 sm:border-t mt-2 p-1">
            <dl class="mb-0">
                    <span class="mt-3 inline-flex rounded-md shadow-sm sm:mt-0 sm:ml-3 sm:w-auto">
                        <button type="button"
                                @click="sendFormData"
                                :disabled="!anythingSelected"
                                :class="{'bg-gray-400': !anythingSelected, 'bg-blue-600 hover:bg-blue-500': anythingSelected}"
                                class="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-white focus:outline-none focus:border-blue-700 focus:ring-indigo-200 active:bg-blue-700 sm:w-auto sm:text-sm sm:leading-5">
                          Resolve Alarm
                        </button>
                      </span>
            </dl>
        </div>
    </div>

</template>

<script>
    import axios from "axios";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    //https://michaelnthiessen.com/this-is-undefined/

    export default {
        name: "alarmAddressResolve",
        props: {
            isMassResolving: Boolean,
            sendEventOnly: Boolean,
        },
        mixins: [SonicuCoreMixin],
        data() {
            return {
                comments: '',
                reason: '',
                willAlarmObject: null,
            }
        },
        computed: {
            anythingSelected() {
                return this.reason.length > 0;
            },
            willAlarm() {
                if(this.willAlarmObject === null){
                    return false;
                }
                if(this.willAlarmObject.type === false){
                    return false;
                }
                if(this.willAlarmObject.type == 'offline'){
                    return "it's offline";
                }
                if(this.willAlarmObject.type == 'threshold'){
                    return "it's outside of its thresholds";
                }
                return false;
            }
        },
        methods: {
            sendFormData() {
                let data = {
                    'addressed': 'resolve',
                    'reason': this.reason,
                    'comments': this.comments,
                }

                if (this.sendEventOnly) {
                    // If we're only sending the event, emit the event and return
                    this.$emit('resolving-alarm', data)
                    return
                }

                axios.patch(window.location.pathname, data
                ).then(response => {
                        window.location.href = this.company.buildCompanyRoute('alarms');
                        return false;
                    }
                );
            },
            checkCurrentPointStatus() {
                axios.get('/api-internal' + window.location.pathname + '/current-point-status')
                    .then(data => {
                        console.log(data);
                        this.willAlarmObject = data.data;
                    });
            }
        },
        mounted() {
            if (! this.isMassResolving) {
                this.checkCurrentPointStatus();
            }
        }
    }
</script>

<style scoped>

</style>